import qs from 'qs'

export class QueryString {
    static stringify(obj: Record<string, any>): string {
        return qs.stringify(obj, { encode: false })
    }

    static stringifyToBackand(obj: Record<string, any>): string {
        const allParams = Object.keys(obj).reduce((params: string[], key: string) => {
            const value = typeof obj[key] === "object" ? JSON.stringify(obj[key]) : obj[key]
            return [...params, `${key}=${value}`]
        }, [])

        return allParams.join('&')
    }

    static parseQueryString(queryString: string): qs.ParsedQs {
        return qs.parse(queryString.slice(1))
    }

    static removeQueryString(): void {
        const cleanUrl = window.location.href.split('?')[0]

        window.history.replaceState({}, '', cleanUrl)
    }

    static removeHash(): void {
        const cleanUrl = window.location.href.split('#')[0]

        window.history.replaceState({}, '', cleanUrl)
    }
}
